import { action } from '@ember/object';
import { service } from '@ember/service';

import type { APIData, Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import type { Args } from 'webapp/components/metric-library/grid-item-base';
import SourceMetricsGridItem from 'webapp/components/source/metrics/grid-item';

export default class ScriptsGridItem<T extends Args> extends SourceMetricsGridItem<T> {
	@service('model-manager/scripts')
	declare mmScriptsService: Service.ModelManager.Scripts;
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;
	@service('analytics') declare analyticsService: Service.Analytics;

	trackingEvent = TrackingEvent.NEW_CALCULATION;
	trackingEventForCreated = TrackingEvent.CALCULATION_CREATED;

	get trackingWizardType(): string | null {
		return null;
	}

	@action
	override createNew() {
		if (this.accountService.handleDemo() || this.isLoading) {
			return;
		}

		this.isLoading = true;
		void this.mmMetricsService
			.addMetricsToHome([this.model])
			.then(() => {
				this.trackCreatedEvent();
			})
			.finally(() => {
				this.isLoading = false;
			});
	}

	trackCreatedEvent() {
		this.analyticsService.event(this.trackingEvent, {
			origin: this.trackingOriginForAdd,
		});

		const eventName = this.trackingEventForCreated,
			eventData: APIData.Tracking.Data = {
				origin: this.trackingOriginForAdd,
				datasource: this.source?.sourceType.key,
			},
			trackingWizardType = this.trackingWizardType;

		if (trackingWizardType) {
			eventData.type = trackingWizardType;
		}

		this.analyticsService.event(eventName, eventData);
	}
}
